import { useMemo } from "react";
import { useSelector } from "react-redux";
import { AppState } from "redux/AppTypes";
import { createSelector } from "reselect";
import { Team, TeamHandle } from "resource-planner-model";

const stateSelector = (state: AppState) => state.teams.items;

function makeLeadsSelector(targetDate: Date) {
  return createSelector(stateSelector, (items): string[] => {
    const leads = Object.values(items).reduce((set, rawTeam: Team) => {
      const team = new TeamHandle(rawTeam);

      if (!team.isOffboarded(targetDate)) {
        set.add(team.lead);
      }
      return set;
    }, new Set<string>());

    return Array.from(leads).sort();
  });
}

export function useLeads(year: number, month: number): string[] {
  const targetDate = useMemo(() => new Date(year, month, 1), [year, month]);
  const selector = useMemo(() => makeLeadsSelector(targetDate), [targetDate]);
  const state = useSelector((state: AppState) => state);
  return selector(state);
}